import React, { useEffect } from 'react';
import { MainTable } from '../../Components/MainTable/MainTable';
import { useTeams } from './TeamStore';
import Add from './Add';
import Edit from './Edit';

function Teams() {
    let { teams, getTeams, columns, setEd, deleteTeam } = useTeams()
    useEffect(() => {
        getTeams()
    }, [getTeams])
    return (
        <MainTable
            pageTitle={'Xodimlar'}
            pdata={teams}
            pcolumns={columns}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteTeam(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}
export default Teams;